import type { RouteRecordRaw } from 'vue-router'

import { DEFAULT_LAYOUT } from '@/router/constant'

const help: RouteRecordRaw = {
  path: '/help',
  name: 'Help',
  component: DEFAULT_LAYOUT,
  redirect: '/help/index',

  children: [
    {
      path: 'redirect',
      name: 'HelpRedirect',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/help/HelpRedirect.vue'),
      meta: { title: 'ヘルプリダイレクト', requiresAuth: true },
    },
  ],
}

export default help
